import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { CardWithAddress } from '@spartacus/checkout/base/components';
import { Address, I18nModule } from '@spartacus/core';
import { AddressTypeIconComponent } from '../address-type-icon/address-type-icon.component';
import { TableProComponent } from '../../../../../../../components/table-pro/table-pro.component';
import { TableProConfig } from '../../../../../../../components/table-pro/core/table-pro.model';

@Component({
  selector: 'table-addresses',
  standalone: true,
  imports: [CommonModule, I18nModule, AddressTypeIconComponent, TableProComponent],
  templateUrl: './table-addresses.component.html',
  styleUrl: './table-addresses.component.scss',
})
export class TableAddressesComponent {
  @ViewChild('container', { static: true }) $container!: ElementRef;

  @Input() addressCards!: CardWithAddress[];
  @Input() currentCard: CardWithAddress | undefined;
  @Output() _onSelectAddress = new EventEmitter<Address>();
  @Output() _onShowNewAddressForm = new EventEmitter();

  tableConfig: TableProConfig = {
    hasItemsPerPageSelector: false,
    collumnConfig: [{ id: 'isDefault', index: 0, type: 'boolean', isOrdenable: false }],
  };

  constructor(private cdr: ChangeDetectorRef) {}

  setAddress(card: CardWithAddress) {
    if (card.address.id !== this.currentCard?.address?.id) {
      this.currentCard = card;
      this._onSelectAddress.emit(card.address);
      this.cdr.detectChanges();
    }
  }

  showNewAddressForm() {
    this._onShowNewAddressForm.emit();
  }
}
